export class CommonAuditConstant{
    public static readonly DESCRIPTION_LABEL: string = 'Description';
    public static readonly EMPTY_SPACE: string = '';
    public static readonly DATESTRING_FORMAT_US: string = 'en-US';
}